"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { onMessage } from "firebase/messaging";
import { useRouter } from "next/navigation";
import { messaging } from "../lib/firebase";

type NotificationType = {
  id: string;
  title: string;
  message: string;
  url?: string;
  unread: boolean;
  time: string;
};

const NotificationContext = createContext<any>(null);

export const NotificationProvider = ({ children }: any) => {
  const [notifications, setNotifications] = useState<NotificationType[]>([]);
  const router = useRouter();

  useEffect(() => {
    if (!messaging) return;

    onMessage(messaging, (payload) => {
      const newNotif: NotificationType = {
        id: crypto.randomUUID(),
        title: payload.notification?.title || "",
        message: payload.notification?.body || "",
        url: payload.data?.url,
        unread: true,
        time: new Date().toLocaleTimeString(),
      };

      setNotifications((prev) => [newNotif, ...prev]);

      // 🔔 Browser notification (foreground)
      new Notification(newNotif.title, {
        body: newNotif.message,
        icon: "/icon.png",
        data: { url: newNotif.url }
      });
    });
  }, []);

  const markAsReadAndNavigate = (notif: NotificationType) => {
    setNotifications((prev) =>
      prev.map((n) =>
        n.id === notif.id ? { ...n, unread: false } : n
      )
    );

    if (notif.url) router.push(notif.url);
  };

  return (
    <NotificationContext.Provider
      value={{ notifications, markAsReadAndNavigate }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
